import { Pipe, PipeTransform } from '@angular/core';
import { FundProductStatusesEnum } from '@spa/api';
import { Helper } from '../classes';

import { LanguageService } from '../language.service';

@Pipe({
  name: 'productStatus'
})
export class ProductStatusPipe implements PipeTransform {
  constructor(private languageService: LanguageService) {
  }

  transform(status: FundProductStatusesEnum): string {
    return Helper.textsHelper().getProductStatusName(status, this.languageService.getCurrentLanguage());
  }
}
